/**
 * Full-screen 3-dot loader — visually identical to the `#fm-boot` splash in
 * public/index.html, so the boot animation never changes mid-load.
 */
export const BootDots = ({ testId = 'boot-dots', inline = false }: { testId?: string; inline?: boolean }) => (
  <div
    data-testid={testId}
    style={{
      minHeight: inline ? 200 : '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 8,
      background: inline ? 'transparent' : '#0a0e14',
    }}
  >
    {['#cafd00', '#00f1fe', '#d277ff'].map((c, i) => (
      <span
        key={c}
        style={{
          width: 9,
          height: 9,
          borderRadius: '50%',
          background: c,
          display: 'block',
          animation: `fm-boot-pulse 1s ease-in-out ${i * 0.15}s infinite`,
        }}
      />
    ))}
    <style>{`@keyframes fm-boot-pulse { 0%,100% { opacity:.25; transform:scale(.8); } 50% { opacity:1; transform:scale(1); } }`}</style>
  </div>
);
